import React from 'react';
import classNames from 'classnames';
import { IconCheck, IconLink } from '../../utils/icons';

interface Props {
  count?: number | null;
  className?: string;
  title?: string;
}

export function PdpCountPill({ count, className, title = 'Product pages (PDP URLs) this is on' }: Props) {
  const total = Number(count) || 0;
  if (total <= 0) return null;

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-[4px] bg-tint text-accent-text rounded-[6px] px-[7px] py-[2px] text-[11.5px] font-semibold leading-[1.45] whitespace-nowrap',
        className
      )}
      title={title}
    >
      <span className="inline-flex -rotate-45">
        <IconLink width={10} height={10} stroke="currentColor" strokeWidth={2.4} />
      </span>
      {total} {total === 1 ? 'PDP' : 'PDPs'}
    </span>
  );
}

/** Sibling of PdpCountPill: the last PDP analysis found one of our videos on
 * `count` of the PDP URLs (a video card: this video; a product card: any of
 * its videos). Renders nothing at zero. */
export function PlacedPill({ count, className, title }: Props) {
  const total = Number(count) || 0;
  if (total <= 0) return null;

  return (
    <span
      className={classNames(
        'inline-flex items-center gap-[4px] bg-tint text-accent-text rounded-[6px] px-[7px] py-[2px] text-[11.5px] font-semibold leading-[1.45] whitespace-nowrap',
        className
      )}
      title={title || `Found on ${total === 1 ? 'the page' : `${total} pages`} by the last PDP analysis`}
    >
      <IconCheck width={11} height={11} stroke="currentColor" />
      Placed
    </span>
  );
}
